<template>
  <div v-if="mainBannerImageUrl">
    <component :is="linkConfig.element" v-bind="linkConfig.attrs">
      <picture>
        <source
          v-if="desktopBannerImageUrl"
          :srcset="lexasSrcset(desktopBannerImageUrl, DESKTOP_WIDTHS, desktopImage.width) || desktopBannerImageUrl"
          sizes="100vw"
          :width="desktopImage.width"
          :height="desktopImage.height"
          media="(min-width: 1024px)"
        >
        <img
          :src="lexasImage(mainBannerImageUrl)"
          :srcset="lexasSrcset(mainBannerImageUrl, MOBILE_WIDTHS, mainImage.width) || undefined"
          sizes="100vw"
          :width="mainImage.width"
          :height="mainImage.height"
          :alt="altText"
          loading="lazy"
          class="w-full h-auto"
        >
      </picture>
    </component>
  </div>
</template>

<script setup>
import { useLexas } from '~/composables/useLexas'
import { lexasImage, lexasSrcset } from '~/helpers/lexasImage'

const MOBILE_WIDTHS = [400, 640, 828]
const DESKTOP_WIDTHS = [1024, 1280, 1536, 1920]

const { getHomePageBanner } = useLexas()

const { data: banner } = await useAsyncData('homePageBanner', () => getHomePageBanner())

const mobileImage = computed(() => banner.value?.mobileImage || {})
const desktopImage = computed(() => banner.value?.desktopImage || {})
const link = computed(() => banner.value?.link || '')

// The mobile image, or the desktop image when there is no mobile one
const mainImage = computed(() => mobileImage.value?.url ? mobileImage.value : desktopImage.value)
const mainBannerImageUrl = computed(() => mainImage.value?.url || '')
const desktopBannerImageUrl = computed(() => desktopImage.value?.url || '')
const altText = computed(() => mobileImage.value?.altText || desktopImage.value?.altText || '')

// Check if the link is an external
const isExternal = computed(() => /^(http|https):\/\//.test(link.value))
const NuxtLink = resolveComponent('NuxtLink')

const linkConfig = computed(() => {
  return link.value
    ? isExternal.value
      // If the link is external, use an anchor tag with target and rel attributes
      ? { element: 'a', attrs: { href: link.value, target: '_blank', rel: 'noopener noreferrer' } }
      // If the link is internal, use NuxtLink
      : { element: NuxtLink, attrs: { to: link.value } }
    // If there's no link, return a div
    : { element: 'div', attrs: {} }
})
</script>
